<template>
  <v-container
    id="subdomain"
    fluid
  >
    <v-row class="d-flex flex-column flex-md-row-reverse thing">
      <v-col
        cols="12"
        md="6"
      >
        <div class="parallelogram">
          <v-row>
            <v-col
              cols="12"
              class="d-flex justify-center align-center full-height"
            >
              <v-container class="unskew px-10 px-md-0 justify-center align-center">
                <div>
                  <h3> A subdomain is required <br> please include one in the url <br> for example <br> subdomain.{{ newUrl }}</h3>
                </div>
              </v-container>
            </v-col>
          </v-row>
        </div>
        <div class="parallelogram2" />
      </v-col>
      <v-col
        cols="12"
        md="6"
        class="d-flex justify-center align-center full-height"
      >
        <v-row class="d-flex flex-column">
          <v-col
            md="12"
            class="d-flex justify-center align-center"
          >
            <img
              src="/img/logo.svg"
              alt="Flo Logo in Blue"
              class="logo-size"
            >
          </v-col>

          <v-col
            md="12"
            class="d-flex justify-center align-center"
          >
            <a
              href="https://flo.co.uk"
              title="Recruitment Software by Flo"
              target="_blank"
              class="powered-by"
            >Recruitment Software by Flo</a>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
export default {
  name: 'Subdomain',
  props: {
    //
  },
  data: () => ({
    newUrl: ''
  }),
  computed: {
    //
  },
  created () {
    this.newUrl = window.location.host
  },
  methods: {
    //
  }
}
</script>
<style lang="scss">
@import './resources/sass/variables';
#subdomain {
    .powered-by {
        text-decoration: none;
        color: grey;
    }
  .pab {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
  }
  .logo-size{
    height: 25vh;
  }
  .register-comp{
    max-width: 95vw;
    max-height: 95vh;
  }
  .unskew{
    text-align: center;
    transform: skewY(-10deg);
    color: white;
    padding: 6rem 1rem;
  }
  @media screen and (min-width: 960px){
    .full-height{
      height: 100vh;
    }
    .logo-size{
      height: 100%;
      min-height: 15vh;
      max-height: 25vh;
    }
    .unskew{
      max-width: 65%;
      transform: skewX(15deg);
      margin: 1rem 1rem;
      padding: 6rem 1rem;
    }
  }
  .parallelogram {
    position: fixed;
    bottom: -10%;
    left: 0;
    width: 100vw;
    height: 70vh;
    min-height: 600px;
    background-color: hsl(203, 75%, 50%);
    transform: skewY(10deg);
    box-shadow: 6px 0px 10px 5px rgba(0,0,0,0.1);
    @media screen and (min-width: 960px) {
      bottom: 0;
      width: 600px;
      height: 100vh;
      transform: skewX(-15deg);
    }
    @media screen and (min-width: 1200px) {
      width: 50vw;
    }
  }
  .parallelogram2 {
    position: fixed;
    bottom: -70%;
    left: 0;
    width: 100vw;
    height: 80vh;
    background-color: hsl(203, 95%, 40%);
    transform: skewY(10deg);
    box-shadow: 6px 0px 10px 5px rgba(0,0,0,0.1);
    @media screen and (min-width: 960px) {
      bottom: 0;
      left: -575px;
      width: 600px;
      height: 100vh;
      transform: skewX(-15deg);
    }
    @media screen and (min-width: 1200px) {
      left: -50%;
      width: 52vw;
    }
  }
}
</style>
